import { AxiosResponse } from "axios";
import firebase from "firebase/app";
import "firebase/firestore";
import { useEffect } from "react";
import { useAppDispatch } from "src/redux";
import api from "src/util/api";
import { isApiError } from "src/util/apiNew";
import { validate } from "../../util/types";
import { tReduxAction } from "../types";
import { tProductDetailsState } from "./types";

type tpFetchProduct = (
  myProductSnapshot: firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>,
) => tReduxAction;
export const fetchProduct: tpFetchProduct = (myProductSnapshot) => (dispatch) => {
  if (myProductSnapshot.empty) {
    dispatch({
      type: "ERROR",
      error: new Error("Product Not Found"),
    });
    return;
  }

  const aProductData = validate("tProduct")(myProductSnapshot.docs[0].data());

  dispatch({
    type: "SET_PRODUCT_DETAILS_DATA",
    productData: aProductData,
  });
};

type tpUseFetchProduct = (myProductId: string) => void;
export const useFetchProduct: tpUseFetchProduct = (myProductId) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return firebase
      .firestore()
      .collectionGroup("products")
      .where("productId", "==", myProductId ?? "")
      .onSnapshot((myProductSnapshot) => {
        dispatch(fetchProduct(myProductSnapshot));
      });
  }, [dispatch, myProductId]);
};

type tpAddProductToCart = (myProductDetails: tProductDetailsState) => tReduxAction;
export const addProductToCart: tpAddProductToCart = (myProductDetails) => (dispatch) => {
  const {
    productData: rProduct,
    quantity: rQuantity,
    variantSelections: rVariantSelections,
    isAvailable: rIsAvailable,
    testerSelected: rTesterSelected,
  } = myProductDetails;

  if (!rIsAvailable) {
    return;
  }

  const aPromises: Array<Promise<AxiosResponse>> = [];
  const aMessage = "Product Successfully Added to Cart";

  if (rProduct.variants.length === 0) {
    aPromises.push(
      api.post({
        endpoint: `/cart/${rProduct.brandUid}/${rProduct.productId}/${rProduct.sku}/${rQuantity.toString()}/add`,
        body: rTesterSelected && rProduct.tester?.sku !== undefined ? { addTester: true } : undefined,
      }),
    );
  } else {
    const aVariant = rProduct.variants.find((myVariant) => {
      return myVariant.options.every(({ name, label }) => {
        if (rVariantSelections && rVariantSelections[name]) {
          return rVariantSelections[name] === label;
        } else {
          return false;
        }
      });
    });

    if (aVariant === undefined) {
      dispatch({ type: "RIBBON", message: new Error("Selected variant does not exist") });
      return;
    }

    aPromises.push(
      api.post({
        endpoint: `/cart/${rProduct.brandUid}/${rProduct.productId}/${aVariant.sku}/${rQuantity.toString()}/add`,
        body: rTesterSelected && aVariant.tester?.sku !== undefined ? { addTester: true } : undefined,
      }),
    );
  }

  dispatch({
    type: "SET_ADDING_PRODUCT",
    loading: true,
  });

  Promise.all(aPromises)
    .then(() => {
      dispatch({
        type: "RIBBON",
        message: aMessage,
      });
    })
    .catch((error) => {
      dispatch({
        type: "RIBBON",
        message: new Error(
          isApiError(error) && error.response ? error.response?.data.message : "An error occurred please try again.",
        ),
      });
    })
    .finally(() => {
      dispatch({
        type: "SET_ADDING_PRODUCT",
        loading: false,
      });
    })
    .catch((error: Error) => {
      dispatch({
        type: "ERROR",
        error,
      });
    });
};
